/**
 * Get the DOM root relative to an element, used for environment agnostic event handling regarding the widget shadow DOM
 * @param element An element to get the root of, if null, the document.body will be returned
 * @returns The root of the element
 */
export function getDomRoot(element: HTMLElement | null): Node {
  if (!element) return document.body;
  return element.getRootNode();
}
